<template>
  <div class="container">
    <!-- <h1 class="text-center">EQUIPMENT FINANCING APPLICATION</h1> -->
    <form-wizard @on-complete="onComplete"
                  @on-change="scrollToTop"
                  ref="wizard"
                  shape="tab"
                  back-button-text="Go back!"
                  next-button-text="Continue"
                  finish-button-text="Submit Application"
                  color="#eff9ff">
        <div slot="title" class="amcredit-font minimal-title text-center text-12-16 f-w-600 color-grey-5 uppercase ls-1">Equipment Financing Application</div>
        <tab-content icon="far fa-hospital" :before-change="validateFirstTab">
          <h3 class="title">Tell us about the equipment you want to finance and your business.</h3>
          <h5 class="color-green">Equipment Information</h5>
          <vue-form-generator :model="model" 
                              :schema="firstTabSchema"
                              :options="formOptions"
                              ref="firstTabForm"
                              >                        
          </vue-form-generator>
        </tab-content>
        <tab-content icon="far fa-sun" :before-change="validateSecondTab">
          <h3 class="title">Next, let's learn a bit more about you.</h3>
          <h5 class="color-green">Business Owner</h5>
          <vue-form-generator :model="model" 
                              :schema="secondTabSchema"
                              :options="formOptions"
                              ref="secondTabForm"
                              >                                
          </vue-form-generator>
          <hr class="col-lg-8">
          <input class="address-check-box" type="checkbox">
          <label class="address-check-label" v-bind:class="{checked: toggle}" @click="toggle = !toggle">Use business address as my mailing address</label>
          <div v-show='!toggle'>
            <br>
            <vue-form-generator :model="model" 
                                :schema="mailingAddressSchema"
                                :options="formOptions"
                                ref="mailingAddressForm"
                                >                                
            </vue-form-generator>
          </div>
          <hr class="col-lg-8">

          <div :style="`display: ${!showOwner2 ? 'none' : 'block'}`">
            <h5 class="color-green">Additional Business Owner<a class="delete-add-owner" @click="deleteOwner2()">✕</a></h5>
            
            <vue-form-generator :model="model" 
                              :schema="addOwnerSchema"
                              :options="formOptions"
                              ref="addOwnerForm"
                              >                                
            </vue-form-generator>
            <hr class="col-lg-8">
            <input class="address-check-box" type="checkbox">
            <label class="address-check-label" v-bind:class="{checked: owner2Toggle}" @click="owner2Toggle = !owner2Toggle">Use business address as my mailing address</label>
            <div v-show='!owner2Toggle'>
              <br>
              <vue-form-generator :model="model" 
                                  :schema="mailingAddress2Schema"
                                  :options="formOptions"
                                  ref="mailingAddress2Form"
                                  >                                
              </vue-form-generator>
            </div>
            <hr class="col-lg-8">
          </div>

          <!-- <div v-for="(addOwner, index) in addOwners" :key="index">
            <h5 class="color-green">Additional Business Owner<a class="delete-add-owner" @click="deleteOwner(index)">✕</a></h5>
            
            <vue-form-generator :model="addOwners[index]" 
                              :schema="addOwnerSchema"
                              :options="formOptions"
                              ref="addOwnerForm"
                              >                                
            </vue-form-generator>
            <hr class="col-lg-8">
            <input class="address-check-box" type="checkbox">
            <label class="address-check-label" v-bind:class="{checked: addOwner.toggle}" @click="addOwner.toggle = !addOwner.toggle">Use business address as my mailing address</label>
            <div v-show='!addOwner.toggle'>
              <br>
              <vue-form-generator :model="model" 
                                  :schema="mailingAddressSchema"
                                  :options="formOptions"
                                  ref="mailingAddressForm"
                                  >                                
              </vue-form-generator>
            </div>
            <hr class="col-lg-8">
          </div> -->
          <button class="amcredit-add-owner" :style="`display: ${showOwner2 ? 'none' : 'block'}`" @click="addOwner2()">Add Owner</button>
        
        </tab-content>
        <tab-content icon="far fa-consent" :before-change="validateConsentTab">
          <h3 class="title consent-title">Almost there. Let's review these required consent agreements.</h3>
          <div class="intro">Please review and agree to the required consents below. When you are ready, submit your application for review.</div>
          <div class="consent-item-wrapper col-lg-8 remove-padding">
            <div @click="displayCreditReport = true" data-open="credit-report-modal" class="flex-container consent-item align-middle" aria-controls="credit-report-modal" aria-haspopup="true" tabindex="0"><div class="media-wrap"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#F0F4F0"></circle> <path d="M17 16L31 16V33H17V16Z" fill="white" stroke="#053a7a" stroke-width="2"></path> <path d="M20.5 24.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 21.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 27.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path></svg></div> <div class="flex-container align-justify full-width"><a href="javascript:void(0);">
              Consent for American Credit to Obtain a Credit Report
            </a></div></div>
            <div @click="displayContactYou = true" data-open="contact-modal" class="flex-container consent-item align-middle" aria-controls="contact-modal" aria-haspopup="true" tabindex="0"><div class="media-wrap"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#F0F4F0"></circle> <path d="M17 16L31 16V33H17V16Z" fill="white" stroke="#053a7a" stroke-width="2"></path> <path d="M20.5 24.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 21.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M20.5 27.5H27.5" stroke="#053a7a" stroke-linecap="round" stroke-linejoin="round"></path></svg></div> <div class="flex-container align-justify full-width"><a href="javascript:void(0);">
              Consent for American Credit to Contact You
            </a></div></div>
          </div>
          <div class="agree-box col-lg-8">
            <div class="row align-justify align-middle">
              <div class="col-md-8">
                <input class="consent-check-box" type="checkbox" id="agree" name="agree">
                <label class="consent-check-label" for="agree" v-bind:class="{checked: consentToggle}" @click="consentToggle = !consentToggle">I agree and acknowledge these consents for American Credit and its Assignees to obtain my credit report and contact me.</label>
              </div>
              <div class="col-md-4 consent-sign" :style="`display: ${consentToggle ? 'block' : 'none'}`">
                <div>
                  <div class="text">{{ model.firstName }} {{ model.lastName }}</div> 
                  <div class="text">{{ currentDate }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="important-notice col-lg-8 remove-padding">
            <p>IMPORTANT INFORMATION ABOUT PROCEDURES FOR BECOMING AN AMERICAN CREDIT CUSTOMER<br>
            To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who receives funding from us.<br>
            What this means for you: When you request financing from us, we will ask for your name, address, date of birth, and other information that will allow us to identify you. We may also ask to see your driver's license or other identifying documents.</p>
            <p>NOTICE: The Federal Equal Credit Opportunity Act prohibits creditors from discriminating against credit applicants on the basis of race, color religion, national origin, sex, marital status, age (provided the applicant has the capacity to enter into a binding contract) because all or part of the applicant's income derives from any public assistance program, or because the applicant has, in good faith, exercised any right under the Consumer Credit Protection Act. The federal agency that administers our compliance with this law is the Federal Trade Commission, Equal Credit Opportunity, Washington, DC 20580</p>
          </div>
        </tab-content>
        <tab-content icon="far fa-rev">
          <h3 class="title">Final step! Review your application's information before you submit.</h3>
          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding"><h5 class="color-green">Business Information</h5></div>
            <div class="col-lg-6 remove-padding"><button class="edit-review uppercase" @click="editBusiness()">Edit</button></div>
            <h6 class="col-lg-6 sub-title remove-padding">Equipment</h6><div class="col-lg-6 remove-padding"></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Equipment Description</div>
              <div class="col-lg-6 item-value">{{this.model.equipmentDescription}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Amount</div>
              <div class="col-lg-6 item-value">{{this.model.equipmentCost}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">New or Used Equipment</div>
              <div class="col-lg-6 item-value">{{this.model.equipmentStatus}}</div>
            </div>
            <div class="col-lg-6 remove-padding"></div><h6 class="col-lg-6 sub-title remove-padding sub-title-margin">Business</h6><div class="col-lg-6 remove-padding"></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Company Legal Name</div>
              <div class="col-lg-6 item-value">{{this.model.companyName}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">State of Incorporation</div>
              <div class="col-lg-6 item-value">{{this.model.stateOfIncorporation}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Federal ID</div>
              <div class="col-lg-6 item-value">{{this.model.FederalID}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Years in Business</div>
              <div class="col-lg-6 item-value">{{this.model.yearsInBusiness}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Address</div>
              <div class="col-lg-6 item-value">{{this.model.address}}<br>{{this.model.address2}}<br>{{this.model.city}},{{this.model.state}} {{this.model.zip}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">What does your business do?</div>
              <div class="col-lg-6 item-value">{{this.model.businessDescription}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Company Email Address</div>
              <div class="col-lg-6 item-value">{{this.model.companyEmail}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Reason for Equipment Purchase</div>
              <div class="col-lg-6 item-value">{{this.model.reasonForEquipment}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Company Phone</div>
              <div class="col-lg-6 item-value">{{this.model.companyPhone}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Tax Classification</div>
              <div class="col-lg-6 item-value">{{this.model.taxClassification}}</div>
            </div>
          </div>

          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Owner Information</h5></div>
            <div class="col-lg-6 remove-padding sub-title-margin"><button class="edit-review uppercase" @click="editOwner()">Edit</button></div>
            <h6 class="col-lg-6 sub-title remove-padding">Business Owner</h6><div class="col-lg-6 remove-padding"></div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Name</div>
              <div class="col-lg-6 item-value">{{this.model.firstName}} {{this.model.lastName}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Phone Number</div>
              <div class="col-lg-6 item-value">{{this.model.personalPhone}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Social Security Number</div>
              <div class="col-lg-6 item-value">{{this.model.ssn}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Business Ownership</div>
              <div class="col-lg-6 item-value">{{this.model.ownership}}%</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Email Address</div>
              <div class="col-lg-6 item-value">{{this.model.personalEmail}}</div>
            </div>
            <div class="col-lg-6 remove-padding review-item row">
              <div class="col-lg-6 item-title">Business address is mailing address?</div>
              <div class="col-lg-6 item-value">{{this.toggle ? 'Yes' : 'No'}}</div>
            </div>
          </div>
          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Related Documents (optional)</h5></div>
            <div class="amcredit-text">Upload any documents related to you or your business. Files must be PDF, JPEG, PNG, DOC or XLS, 25mb max.</div>
            <div class="amcredit-text">Not sure what documents to upload? Visit <a href="https://amcredit.com/blog/amcredit-loan-submission-documents/" target="_blank">American Credit® Loan Submission Documents</a> to check out the list.</div>
            <div class="remove-padding col-lg-12">
              <multiple-uploads @ready="childVal => { uploadedFiles = childVal }" />
            </div>
          </div>

          <div class="review-section col-lg-8 row">
            <div class="col-lg-6 remove-padding sub-title-margin"><h5 class="color-green">Notes (optional)</h5></div>
            <div class="remove-padding col-lg-12">
              <textarea v-model="brokerNote" name="application-notes" id="application-notes" cols="30" rows="4"></textarea>
            </div>
          </div>

        </tab-content>
    </form-wizard>

    <div class="reveal-overlay" :style="`display: ${model.displayPromoCode ? 'block' : 'none'}`">
      <div id="contact-modal" data-reveal="2ocrej-reveal" class="reveal small" role="dialog" aria-hidden="false" data-yeti-box="contact-modal" data-resize="contact-modal" data-events="resize" tabindex="-1" style="top: 41px; display: block;">
        <button data-close="" aria-label="Close modal" type="button" class="close-button" @click="model.displayPromoCode = false">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z" fill="#787D78"></path></svg>
        </button> 
        <h4>Promotion code applied successfully!</h4> 
        <div class="intro color-gray ls-n-p-1 f-w-400">Your promotion code <strong>{{this.model.promoCode}}</strong> has been applied successfully. Once your loan is successfully funded, you will receive $100 cash rebate.</div> 
        <hr>
        <div class="text-right"><button data-close="" class="button" @click="model.displayPromoCode = false">OK</button></div>
      </div>
    </div>

    <div class="reveal-overlay" :style="`display: ${displayContactYou ? 'block' : 'none'}`">
      <div id="contact-modal" data-reveal="2ocrej-reveal" class="reveal small" role="dialog" aria-hidden="false" data-yeti-box="contact-modal" data-resize="contact-modal" data-events="resize" tabindex="-1" style="top: 41px; display: block;">
        <button data-close="" aria-label="Close modal" type="button" class="close-button" @click="displayContactYou = false">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z" fill="#787D78"></path></svg>
        </button> 
        <h4>Consent for American Credit to Contact You</h4> 
        <div class="intro color-gray ls-n-p-1 f-w-400">I hereby confirm that by providing American Credit and its assignees, partners, lenders, or funding service (“Assignees”) with an email address or telephone number, including for a wireless device, I have obtained and am authorized to provide, the necessary express consent from each Company Owner, and that by submitting this Application, I expressly consent on behalf of each Company Owner to communications including email, voice and text messages from, or on behalf of, American Credit and its Assignees, regardless of their purpose, including but not limited to marketing or collection purposes. 
          I understand and agree that: (i) these calls and messages may be subject to charges from an internet or wireless provider; (ii) this consent is not a condition of doing business with, or making a purchase of any goods/services from, American Credit and its Assignees; and (iii) any Company Owner may unsubscribe or opt-out of any further telemarketing calls or marketing text messages at any time.</div> 
        <hr>
        <div class="text-right"><button data-close="" class="button" @click="displayContactYou = false">OK</button></div>
      </div>
    </div>

    <div class="reveal-overlay" :style="`display: ${displayCreditReport ? 'block' : 'none'}`">
      <div id="contact-modal" data-reveal="2ocrej-reveal" class="reveal small" role="dialog" aria-hidden="false" data-yeti-box="contact-modal" data-resize="contact-modal" data-events="resize" tabindex="-1" style="top: 41px; display: block;">
        <button data-close="" aria-label="Close modal" type="button" class="close-button" @click="displayCreditReport = false">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99809 8.70715L11.6445 12.3536L12.3516 11.6465L8.70519 8.00004L12.3516 4.35359L11.6445 3.64648L7.99809 7.29293L4.35164 3.64648L3.64453 4.35359L7.29098 8.00004L3.64453 11.6465L4.35164 12.3536L7.99809 8.70715Z" fill="#787D78"></path></svg>
        </button> 
        <h4>Consent for American Credit to Obtain a Credit Report</h4> 
        <div class="intro color-gray ls-n-p-1 f-w-400">I hereby confirm that each Company Owner of the Company provided in this Application (i) is aware of the Company's request for financing; (ii) may be required to guaranty the requested financing; and (iii) have authorized American Credit, its assignees, partners, lenders, or funding service (“Assignees”) to obtain their respective consumer or business credit reports, as well as use this application and all supporting documentation, now and from time to time, in the credit application and review process.<br><br>
        By selecting ‘I agree’, I am authorized to, and hereby permit, American Credit and its Assignees to obtain (i) a consumer credit report on each Company Owner for credit purposes & further authorize the release to American Credit and its Assignees of all credit information it may request, including business & personal banking, mortgage, landlord, trade & lease information related to each of them; and (ii) confirm that each Company Owner of the company has provided the Credit Consent.</div> 
        <hr>
        <div class="text-right"><button data-close="" class="button" @click="displayCreditReport = false">OK</button></div>
      </div>
    </div>
  </div>
  
</template>

<script>
// import Vue from 'vue'
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Loading } from "element-ui";
import * as types from "../vuex/types";
import VueFormGenerator from 'vue-form-generator'
import MultipleUploads from './applyLoan/MultipleUploads.vue'
// import 'vue-form-generator/dist/vfg.css'
import api from "../vuex/api/index";
import axios from 'axios';
import Cleave from 'cleave.js';
import moment from 'moment';
import { validators } from "vue-form-generator";

// Vue.use(VueFormGenerator)

export default {
  name: "ApplyForm",
  components: {
    "vue-form-generator": VueFormGenerator.component,
    MultipleUploads
	},
  data () {
    return {
      owner2Toggle: true,
      showOwner2: false,
      displayCreditReport: false,
      displayContactYou: false,
      uploadedFiles: null,
      addOwners:[],
      consentToggle: false,
      toggle: true,
      brokerNote: '',
      model:{
        promoCode: '',
        displayPromoCode: false,
        loanTerm: '',
        customerType: '1',
        equipmentDescription:'',
        equipmentStatus:'',
        equipmentCost:'',
        downPayment:'',
        downPaymentAmount:'',
        companyName:'',
        FederalID:'',
        address:'',
        address2:'',
        city:'',
        state:null,
        zip:'',
        companyEmail:'',
        companyPhone:'',
        stateOfIncorporation:null,
        yearsInBusiness:'',
        businessDescription:null,
        reasonForEquipment:null,
        taxClassification:null,
        firstName:'',
        lastName:'',
        ssn:'',
        ownership:'',
        personalEmail:'',
        personalPhone:'',
        ownerAddress:'',
        ownerAddress2:'',
        ownerCity:'',
        ownerState:null,
        ownerZip:'',
        owner2FirstName:'',
        owner2LastName:'',
        owner2Ssn:'',
        owner2Ownership:'',
        owner2PersonalEmail:'',
        owner2PersonalPhone:'',
        owner2Address:'',
        owner2Address2:'',
        owner2City:'',
        owner2State:null,
        owner2Zip:''
      },
   formOptions: {
    validationErrorClass: "has-error",
    validationSuccessClass: "has-success",
    validateAfterChanged: true
   },
   firstTabSchema:{
     fields:[
      {
        type: 'select',
        label: 'What kind of equipment are you financing?',
        model: 'equipmentDescription',
        values: ['Agriculture', 'Air Transportation', 'Automotive', 'Building Automation', 'Commercial', 'Construction', 'Fitness & Spa', 'Food Service', 'Intermodal', 'Landscaping', 'Logging', 'Manufacturing', 'Marine Transportation', 'Material Handling', 'Medical', 'Packaging', 'Printing', 'Rail Transportation', 'Software', 'Technology - A/V', 'Technology - Commercial', 'Technology - Infrastructure', 'Trailer - OTR', 'Trailer - Vocational', 'Truck - OTR', 'Truck - Vocational', 'XX Accessories'],
        required: true,
        validator: "required",
        selectOptions: {
          hideNoneSelectedText: true
        },
        styleClasses: 'col-lg-4',
        onValidated: function(model, errors, field) {
          field.styleClasses = 'col-lg-4 selected';
        }
      },
      {
        type: 'radios',
        label: 'Is this equipment new or used?',
        model: 'equipmentStatus',
        values:['New', 'Used'],
        required: true,
        validator: "required",
        styleClasses:'col-lg-4 input-type-radio'
      },{
        type: "input",
				inputType: "number",
        label: "How much do you want to borrow?",
        model: "equipmentCost",
        required: true,
        validator: VueFormGenerator.validators.number,
        styleClasses:'col-lg-8 custom-lg-8 input-type-number'
     },
     {
        type: 'radios',
        label: 'Do you want to make a down payment?',
        model: 'downPayment',
        values:[
          {
            name: "Yes",
            value: true
          },
          {
            name: "No",
            value: false
          }
        ],
        required: true,
        validator: "required",
        styleClasses:'col-lg-4 input-type-radio'
     },{
        type: "input",
				inputType: "number",
        label: "How much do you want to put down?",
        model: "downPaymentAmount",
        required: true,
        validator: VueFormGenerator.validators.number,
        styleClasses:'col-lg-8 custom-lg-8 input-type-number',
        visible(model) {
            return model && model.downPayment;
        }
     },
     {
        type: "input",
        inputType: "text",
        label: "Business Information",
        placeholder: "Company Legal Name",
        model: "companyName",
        required: true,
        validator: ["string", "required"],
        styleClasses:'col-lg-4 custom-input input-label-placeholder input-top-placeholder'
     },
     {
        type: "cleave",
				inputType: "text",
        placeholder: "Federal ID",
        model: "FederalID",
        required: true,
        min: 10,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid EIN."
        }),
        cleaveOptions: {
          blocks: [2, 7],
          delimiter: "-",
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input-padding custom-input input-label-placeholder input-top-placeholder'
     },
      {
        type: "input",
				inputType: "text",
        placeholder: "Address",
        model: "address",
        required: true,
        validator: ["string", "required"],
        styleClasses: 'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Address Line 2",
        model: "address2",
        validator: VueFormGenerator.validators.string,
        styleClasses: 'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "City",
        model: "city",
        required: true,
        validator: VueFormGenerator.validators.string,
        styleClasses: 'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'State',
        model: 'state',
        required: true,
        validator: "required",
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        selectOptions: {
          noneSelectedText: "State"
        },
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: "cleave",
				inputType: "text",
        model: "zip",
        placeholder: "Zip",
        required:true,
        min: 5,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid zip."
        }),
        cleaveOptions: {
          blocks: [5],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
				inputType: "email",
        model: "companyEmail",
        placeholder: "Company Email Address",
        required:true,
        validator:VueFormGenerator.validators.email,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "cleave",
				inputType: "text",
        model: "companyPhone",
        placeholder: "Company Phone",
        required:true,
        min: 13,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid number."
        }),
        cleaveOptions: {
          blocks: [0, 3, 3, 4],
          delimiters: ["(", ")", "-"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'State of Incorporation',
        model: 'stateOfIncorporation',
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        required:true,
        validator: "required",
        selectOptions: {
          noneSelectedText: "State of Incorporation"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
       type: 'input',
       inputType: 'number',
       model: "yearsInBusiness",
       placeholder: 'Years in Business',
       required:true,
       validator: "required",
       styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'What Does Your Business Do?',
        model: 'businessDescription',
        values: ['Agriculture - Farming & Livestock', 'Consumer Discretionary - Automotive', 'Consumer Discretionary - Bars & Restaurants', 'Consumer Discretionary - DTC', 'Consumer Discretionary - Homebuilding', 'Consumer Discretionary - Hospitality', 'Consumer Discretionary - Leisure', 'Consumer Discretionary - Media', 'Consumer Discretionary - Non-traditional Food', 'Consumer Discretionary - Private Passenger Transportation', 'Consumer Discretionary - Services', 'Consumer Staples - Food & Beverages', 'Consumer Staples - Non-durable Goods', 'Consumer Staples - Public Passenger Transportation', 'Energy - Coal & Consumables', 'Energy - Oil & Gas', 'Energy - Renewables', 'Financial Services - Diversified', 'Financial Services - Non-traditional', 'Health Care - Equipment Manufacturing', 'Health Care - Life Sciences', 'Health Care - Services', 'Industrial - Aerospace & Defense', 'Industrial- Commercial Printing', 'Industrial - Construction Services', 'Industrial - Distribution and Logistics', 'Industrial - Diversified Manufacturing', 'Industrial - Electrical Components', 'Industrial - Environmental & Facilities Services', 'Industrial - Industrial Transportation', 'Industrial - Long-haul Transportation', 'Industrial - Machinery and Equipment', 'Industrial - Short-haul Transportation', 'Infrastructure - Ground', 'Infrastructure - Utilities', 'Materials - Chemical Products', 'Materials - Construction Products', 'Materials - Forest Products', 'Materials - Metals & Mining', 'Materials - Non-metal Recycling', 'Materials - Precious Metals', 'Technology - Commercial Services', 'Technology - Equipment Manufacturing', 'Technology - IT Services', 'Technology - Network Operators'],
        required:true,
        validator: "required",
        styleClasses:'col-lg-8 custom-input custom-lg-8 select-top-placeholder',
        selectOptions: {
          noneSelectedText: "What Does Your Business Do?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Reason for Equipment Purchase?',
        model: 'reasonForEquipment',
        values: ['Business Growth', 'Starting New Business', 'Refinancing', 'Replacement'],
        required:true,
        validator: "required",
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Reason for Equipment Purchase?"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: 'select',
        placeholder: 'Tax Classification',
        model: 'taxClassification',
        values: ['C corp', 'Federal Government', 'Limited Liability Partnership', 'Limited Liability Limited Partnership', 'LLC', 'Non Profit', 'Partnership', 'Professional Corporation', 'S Corp', 'Sole Prop', 'State/Local Government', 'Other'],
        required:true,
        validator: "required",
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "Tax Classification"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     }]
   },
   secondTabSchema:{
     fields:[
      {
        type: "input",
        inputType: "text",
        placeholder: "First Name",
        model: "firstName",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
          type: "input",
          inputType: "text",
          placeholder: "Last Name",
          model: "lastName",
          required:true,
          validator:VueFormGenerator.validators.string,
          styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
          type: "cleave",
          inputType: "text",
          placeholder: "Social Security Number",
          model: "ssn",
          required:true,
          min: 9,
          validator: validators.string.locale({
            fieldIsRequired: "This field is required!",
            textTooSmall: "Please input a valid SSN."
          }),
          cleaveOptions: {
            blocks: [9],
            numericOnly: true
          },
          hint: 'We conduct soft credit pull only. It will not affect your credit score.',
          styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
        type: "input",
				inputType: "number",
        placeholder: "Business Ownership Percentage",
        model: "ownership",
        required:true,
        validator: ['number', 'required'],
        min: 1,
        max: 100,
        hint: "<br>",
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
        type: "input",
				inputType: "email",
        placeholder: "Email Address",
        model: "personalEmail",
        hint: "<br><br>",
        required:true,
        validator:VueFormGenerator.validators.email,
        disabled: function (model) {
          return model.customerType == '1';
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
        type: "cleave",
				inputType: "text",
        placeholder: "Mobile Phone",
        model: "personalPhone",
        hint: "By providing your mobile number, you agree to receive communication from American Credit by call or text. Standard data or messaging rates may apply.",
        required:true,
        min: 13,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid number."
        }),
        cleaveOptions: {
          blocks: [0, 3, 3, 4],
          delimiters: ["(", ")", "-"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      }
     ]
   },
   addOwnerSchema: {
     fields:[
      {
        type: "input",
        inputType: "text",
        placeholder: "First Name",
        model: "owner2FirstName",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "input",
        inputType: "text",
        placeholder: "Last Name",
        model: "owner2LastName",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
     {
        type: "cleave",
        inputType: "text",
        placeholder: "Social Security Number",
        model: "owner2Ssn",
        required:true,
        min: 9,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid SSN."
        }),
        cleaveOptions: {
          blocks: [9],
          numericOnly: true
        },
        hint: 'We conduct soft credit pull only. It will not affect your credit score.',
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     },
      {
        type: "input",
				inputType: "number",
        placeholder: "Business Ownership Percentage",
        model: "owner2Ownership",
        required:true,
        validator: ['number', 'required', 'checkTotalOwnership'],
        min: 1,
        max: 100,
        hint: "<br>",
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
        type: "input",
				inputType: "email",
        placeholder: "Email Address",
        model: "owner2PersonalEmail",
        hint: "<br><br>",
        required:true,
        validator:VueFormGenerator.validators.email,
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      },
      {
        type: "cleave",
				inputType: "phone",
        placeholder: "Mobile Phone",
        model: "owner2PersonalPhone",
        hint: "By providing your mobile number, you agree to receive communication from American Credit by call or text. Standard data or messaging rates may apply.",
        required:true,
        min: 13,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid number."
        }),
        cleaveOptions: {
          blocks: [0, 3, 3, 4],
          delimiters: ["(", ")", "-"],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
      }
     ]
   },
   mailingAddressSchema:{
     fields: [
      {
        type: "input",
				inputType: "text",
        placeholder: "Address",
        model: "ownerAddress",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Address Line 2",
        model: "ownerAddress2",
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "City",
        model: "ownerCity",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'State',
        model: 'ownerState',
        required:true,
        validator: "required",
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "State"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: "cleave",
				inputType: "text",
        model: "ownerZip",
        placeholder: "Zip",
        required:true,
        min: 5,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid zip."
        }),
        cleaveOptions: {
          blocks: [5],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }
     ]
   },
   mailingAddress2Schema:{
     fields: [
      {
        type: "input",
				inputType: "text",
        placeholder: "Address",
        model: "owner2Address",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "Address Line 2",
        model: "owner2Address2",
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: "input",
				inputType: "text",
        placeholder: "City",
        model: "owner2City",
        required:true,
        validator:VueFormGenerator.validators.string,
        styleClasses:'col-lg-8 custom-input custom-lg-8 input-top-placeholder'
     },
     {
        type: 'select',
        placeholder: 'State',
        model: 'owner2State',
        required:true,
        validator: "required",
        values: ['Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut','Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa','Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan','Minnesota','Mississippi','Missouri','Montana','Nebraska','Nevada','New Hampshire','New Jersey','New Mexico','New York','North Carolina','North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island','South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont','Virginia','Washington','West Virginia','Wisconsin','Wyoming'],
        styleClasses:'col-lg-4 custom-input select-top-placeholder',
        selectOptions: {
          noneSelectedText: "State"
        },
        onChanged: function(model, newVal, oldVal, field) {
          field.styleClasses = field.styleClasses + ' selected';
        }
     },
     {
        type: "cleave",
				inputType: "text",
        model: "owner2Zip",
        placeholder: "Zip",
        required:true,
        min: 5,
        validator: validators.string.locale({
          fieldIsRequired: "This field is required!",
          textTooSmall: "Please input a valid zip."
        }),
        cleaveOptions: {
          blocks: [5],
          numericOnly: true
        },
        styleClasses:'col-lg-4 custom-input input-top-placeholder'
     }
     ]
   }
  }
 },
 computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    }),
    currentDate: function() {
      return moment(new Date()).format('MM/DD/YY');
    }
  },
  methods: {
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    onComplete: function(){
      // alert('Yay. Done!');
      // return console.log(this.uploadedFiles);
      this.apply();
    },
    checkFileTypes(files) {
      var allTypesSelected = true;
      files.forEach(file => {
        if(!file.category || file.category == '') {
          allTypesSelected = false;
        }
      })
      return allTypesSelected;
    },

    apply() {
      if(this.uploadedFiles && this.uploadedFiles.length > 0) {
        if(!this.checkFileTypes(this.uploadedFiles)) {
          this.setAlertMessage({
            show: true,
            content: "Please select types for all uploaded documents first!"
          });
        }
      }

      //add loading animation after click submit
      Loading.service({ fullscreen: true, lock: true });
      setTimeout(() => {
        Loading.service({ fullscreen: true, lock: true }).close();
      }, 3000)

      var _this = this;
      if(_this.model.customerType == '1') {
        _this.clientCustomerId = _this.userInfo.crmCustomerId;
        var applyData = {
          tokenId: _this.userInfo.token,
          clientCustomerId: _this.userInfo.crmCustomerId,
          frontApplyProductId: 10000057823975,
          frontApplyMoney: _this.model.equipmentCost,
          frontInformationSources: '5',
          frontApplyExpiresUnit: 2
        };

        if(_this.model.loanTerm && _this.model.loanTerm != '') {
          applyData.frontApplyExpires = _this.model.loanTerm;
        }

        api.mgxyBrokerApply(applyData)
        .then(res => {
          console.log(res);
          var _data = res.data;
          if (_data.code == 0) {
            _this.frontApplyId = _data.result.frontApplyId;

            //save contats to hubspot
            this.createOrUpdateHubspotContact(true);

            if(this.uploadedFiles && this.uploadedFiles.length > 0) {
              //save files into database
              var filesToSave = {
                files: _this.uploadedFiles,
                application_id: _this.frontApplyId
              }
              axios.post("https://api.amcredit.com/apply/update", filesToSave);
            }

            api.postForm("/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht",
              {
                tokenId: _this.userInfo.token,
                frontApplyId: _this.frontApplyId
              }
            ).then(res => {
              // _this.isLoading = false;
              _this.saveBusinessOwner();
            });
          } else {
            //save contats to hubspot
            this.createOrUpdateHubspotContact(false);
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
      } else {
        this.submitLoanApplication();
      }
    },

    submitLoanApplication() {
      var _this = this;
      var registerData = {
          firstName: _this.model.firstName,
          lastName: _this.model.lastName,
          middleName: '',
          email: _this.model.personalEmail,
          brokerId: _this.userInfo.crmCustomerId
      }

      api.brokerRegisterUser(registerData)
      .then(res => {
        if (Number(res.data.code) == 0) {
          var data = res.data.data;
          _this.clientCustomerId = data.crmCustomerId;
          
          api.mgxyBrokerApply({
              tokenId: _this.userInfo.token,
              clientCustomerId: _this.clientCustomerId,
              frontApplyProductId: 10000057823975,
              frontApplyMoney: _this.model.equipmentCost,
              frontInformationSources: '5',
              frontApplyExpiresUnit: 2
            })
            .then(res => {
              console.log(res);
              var _data = res.data;
              if (_data.code == 0) {
                _this.frontApplyId = _data.result.frontApplyId;

                //save contats to hubspot
                this.createOrUpdateHubspotContact(true);

                //save files into database
                var filesToSave = {
                  files: _this.uploadedFiles,
                  application_id: _this.frontApplyId
                }
                axios.post("https://api.amcredit.com/apply/update", filesToSave);

                api.postForm("/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht",
                  {
                    tokenId: _this.userInfo.token,
                    frontApplyId: _this.frontApplyId
                  }
                ).then(res => {
                  // _this.isLoading = false;
                  _this.saveBusinessOwner();
                });
              } else {
                //save contats to hubspot
                this.createOrUpdateHubspotContact(false);
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
          return true;
        } else {
          if (res.data.result === "Registration failed, email has been registered") {
            this.setAlertMessage({
              show: true,
              content: 'Failed to submit application, business owner email already exist'
            });
            // alert("Failed to submit application, business owner email already exist");
          }
          return false;
        }
      });
    },

    saveBusinessOwner() {
      var _this = this;
      var postData = {
        customerId: _this.clientCustomerId,
        tokenId: _this.userInfo.token,

        firstName: _this.model.firstName,
        lastName: _this.model.lastName,
        phone: _this.model.personalPhone,
        streetAddress: _this.model.ownerAddress,
        streetAddressLine2: _this.model.ownerAddress2,
        cityName: _this.model.ownerCity,
        state: _this.model.ownerState,
        ssn: _this.model.ssn,
        zipCode: _this.model.ownerZip,
        title: _this.model.title || "",

        firstName2: _this.model.owner2FirstName,
        lastName2: _this.model.owner2LastName,
        ssn2: _this.model.owner2Ssn,
        email2: _this.model.owner2PersonalEmail,
        phone2: _this.model.owner2PersonalPhone,
        streetAddress2: _this.model.owner2Address,
        streetAddress2Line2: _this.model.owner2Address2,
        cityName2: _this.model.owner2City,
        state2: _this.model.owner2State || "",
        zipCode2: _this.model.owner2Zip,

        isValid: 1,
        customer_area: "",
        military: false,

        businessOwnership: _this.model.ownership,
        businessOwnership2: _this.model.owner2Ownership
      }

      // if(_this.$route.query.email) {
      //   postData.firstName = _this.model.firstName;
      //   postData.lastName = _this.model.lastName;
      // }

      if(_this.toggle) {
        postData.streetAddress = _this.model.address;
        postData.streetAddressLine2 = _this.model.address2;
        postData.cityName = _this.model.city;
        postData.state = _this.model.state;
        postData.zipCode = _this.model.zip;
      }

      if(_this.showOwner2 && _this.owner2Toggle) {
        postData.streetAddress2 = _this.model.address;
        postData.streetAddress2Line2 = _this.model.address2;
        postData.cityName2 = _this.model.city;
        postData.state2 = _this.model.state;
        postData.zipCode2 = _this.model.zip;
      }

      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyBrokerUpdateApplyForPersonDetails.ht",
          postData 
        )
        .then(res => {
          console.log(res);
          var _data = res.data;
          this.isLoading = false;
          if (_data.code == 0) {
            // this.setAlertMessage({
            //   show: true,
            //   content: "Success to save personal information"
            // });
            console.log("Success to save personal information");
            _this.submitBusinessInfo();
          } else {
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
    },

    submitBusinessInfo() {
      var _this = this;
      api.postForm("/mobile/item/loanItemFrontApply/updateSBL01.ht", {
        tokenId: _this.userInfo.token,
        customerId: _this.clientCustomerId,
        frontApplyId: _this.frontApplyId,
        
        name: _this.model.companyName,
        street: _this.model.address,
        street2: _this.model.address2,
        city: _this.model.city,
        state: _this.model.state,
        zipCode: _this.model.zip,
        phone: _this.model.companyPhone,
        tin: _this.model.FederalID,
        structure: _this.model.taxClassification,
        industry: _this.model.businessDescription,
        yearsInBusiness: _this.model.yearsInBusiness,
        businessDesc: _this.brokerNote,
        companyEmail: _this.model.companyEmail,
        stateOfIncorporation: _this.model.stateOfIncorporation
      }).then(res => {
        //             alert(res.date.code);
        //             alert(res.date.msg);
        var _data = res.data;
        if (_data.code == 0) {
          console.log(res);
          // this.setAlertMessage({
          //   show: true,
          //   content: "Success to save business information"
          // });
          console.log("Success to save business information");
          _this.submitVendorForm();
        } else {
          this.setAlertMessage({
            show: true,
            content: _data.msg
          });
        }
      });
    },

    submitVendorForm() {
      var vendorData = {
        tokenId: this.userInfo.token,
        customerId: this.clientCustomerId,
        frontApplyId: this.frontApplyId,

        wantDownPayment: this.model.downPayment,
        downPaymentAmount: this.model.downPaymentAmount,
        reasonForEquipment: this.model.reasonForEquipment,
        equipmentAmount: this.model.equipmentCost,
        // brokerNote: this.brokerNote,
        equipmentStatus: this.model.equipmentStatus,
        equipmentType: this.model.equipmentDescription
      }

      api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", vendorData)
        .then(res => {
          console.log(res);
          console.log("Success to save vendor information");

          //send welcome email to new applicant
          axios.post("https://api.amcredit.com/apply/sendTransactionalEmail", {customerEmail: this.model.personalEmail, firstName: this.model.firstName, emailTemplate: 'amcredit-application-completed-welcome', emailSubject: 'Thank you for choosing American Credit for your equipment financing' })
          .then(res => console.log(res))
          .catch(err => console.log(err.message));

          var sendData = {
            email: this.model.personalEmail, 
            firstName: this.model.firstName, 
            lastName: this.model.lastName, 
            phone: this.model.personalPhone, 
            name: this.model.companyName, 
            message: 'Customer submitted new equipment loan application!'
          }
          // new application slack notification
          axios.create({ transformRequest: [(data, _headers) => JSON.stringify(data)] })
                  .post('https://hooks.zapier.com/hooks/catch/11204908/bpsg1lq/', sendData);

          this.setSuccessMessage({
            show: true,
            content: "Submission successful!"
          });
          setTimeout(() => {
            this.$router.push(this.model.customerType == '1'? '/apply/thank-you' : '/brokerCenter');
            window.location.reload(true);
          }, 3000)
        });
    },

    createOrUpdateHubspotContact (applied) {
      var _this = this;
      // hubspot create new contact
      // POST request using axios with set headers

      var dataProperties = [
        { property: 'applied_successfully', value: applied },
        { property: 'website_new_apply_tag', value: 'Website new application process leads' },
        { property: 'applied_product', value: 'SBEL_product' },
        { property: 'company', value: _this.model.companyName },
        { property: 'business_phone', value: _this.model.companyPhone },
        { property: 'business_structure_transmit', value: _this.model.taxClassification },
        { property: 'business_address', value: _this.model.address },
        { property: 'business_city', value: _this.model.city },
        { property: 'business_state_transmit', value: _this.model.state },
        { property: 'business_zip_code', value: _this.model.zip },
        { property: 'firstname', value: _this.model.firstName },
        { property: 'lastname', value: _this.model.lastName },
        { property: 'address', value: _this.model.ownerAddress },
        { property: 'city', value: _this.model.ownerCity },
        { property: 'state', value: _this.model.ownerState },
        { property: 'zip', value: _this.model.ownerZip },
        { property: 'phone', value: _this.model.personalPhone },
        { property: 'ownership_percentage', value: _this.model.ownership },
        { property: 'first_name_person_2', value: _this.model.owner2FirstName },
        { property: 'last_name_person_2', value: _this.model.owner2LastName },
        { property: 'street_address_person_2', value: _this.model.owner2Address },
        { property: 'city_person_2', value: _this.model.owner2City },
        { property: 'state_person_2_transmit', value: _this.model.owner2State },
        { property: 'postal_code_person_2', value: _this.model.owner2Zip },
        { property: 'phone_person_2', value: _this.model.owner2PersonalPhone },
        { property: 'ownership_person_2', value: _this.model.owner2PersonalEmail }
      ];

      if(_this.model.equipmentCost != '') {
        dataProperties.push({ property: 'deal_amount', value: _this.model.equipmentCost });
      }

      // if(_this.model.term != '') {
      //   dataProperties.push({ property: 'deal_loan_term', value: _this.model.term });
      // }

      console.log(dataProperties)

      const body = {
        email: _this.model.personalEmail,
        data: {
          properties: dataProperties
        }
      }
      const headers = {
        'Content-Type': 'application/json'
      }

      axios({
        url: '/hsapi/create_or_update_contact',
        method: 'post',
        baseURL: 'https://api.amcredit.com/hubspot',
        data: body,
        headers: headers
      })
        .then(response => console.log(response))
        .catch(error => console.log(error.message))
    },


    scrollToTop: function() {
      window.scrollTo(0,0);
    },

    validateFirstTab: function(){
      // return true;
      return this.$refs.firstTabForm.validate();
    },
    validateSecondTab: function(){
      // return true;

      var _this = this;
      let valid_owner = this.$refs.secondTabForm.validate(),
          valid_owner_address = true,
          valid_owner2 = true,
          valid_owner2_address = true;

      if(!_this.toggle) {
        valid_owner_address = this.$refs.mailingAddressForm.validate();
      }

      if(_this.showOwner2) {
        valid_owner2 = this.$refs.addOwnerForm.validate();
        if(!_this.owner2Toggle) {
          valid_owner2_address = this.$refs.mailingAddress2Form.validate();
        }
      }

      return valid_owner && valid_owner_address && valid_owner2 && valid_owner2_address;
    },

    validateConsentTab: function(){
      if(this.consentToggle) {
        this.signAgreement();
        return true;
      } else {
        this.setAlertMessage({
          show: true,
          content: 'You need to review and agree with the consent clauses to proceed.'
        });
        return false;
      }
      
    },

    signAgreement() {
      const _this = this;
      var fullName = _this.model.firstName + ' ' + _this.model.lastName;
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyConfirmSignDeclaration.ht",
          {
            tokenId: _this.userInfo.token,
            contractId: 10000058500118,
            fullName: fullName
          }
        )
        .then(res => {
          const data = res.data;
          console.log(data.msg);
        });
    },

    addOwner: function(){
      var newAddOwner = {toggle: true}
      this.addOwners.push(newAddOwner);
    },

    deleteOwner: function(index){
      this.addOwners.splice(index, 1);
    },

    addOwner2: function(){
      this.showOwner2 = true;
    },

    deleteOwner2: function(index){
      this.showOwner2 = false;
    },

    editBusiness: function() {
      this.$refs.wizard.changeTab(3, 0);
    },

    editOwner: function() {
      this.$refs.wizard.changeTab(3, 1);
    }
  },    
  mounted() {
    if(this.$route.query.amount) {
      this.model.equipmentCost = Number(this.$route.query.amount);
    }
    if(this.$route.query.term) {
      this.model.loanTerm = this.$route.query.term * 12;
    }
    if(this.$route.query.equipment) {
      this.model.equipmentDescription = this.$route.query.equipment;
    }
    if(this.$route.query.yearsInBusiness) {
      this.model.yearsInBusiness = this.$route.query.yearsInBusiness;
    }
    console.log(this.userInfo);
    this.model.promoCode = this.userInfo.promoCode;
    if(this.userInfo.promoCode.toLowerCase() == 'amcredit') {
      this.model.displayPromoCode = true;
    }
    this.model.customerType = this.userInfo.crmCustomerType;
    if(this.model.customerType == '1') {
      this.model.personalEmail = this.userInfo.crmCustomerLoginName;
    }
    VueFormGenerator.validators.checkTotalOwnership = function(value, field, model) {
      if(model.ownership > 0 && model.ownership + value > 100) {
        return ["Total business ownership cannot exceed 100%"];
      }
    }
    // this.getPersonalInitData({
    //   token: this.userInfo.token,
    //   customerId: this.userInfo.crmCustomerId
    // }).then(res => {
    //   console.log(res);
    //   if (Number(res.data.code) === 0) {
    //     const data = res.data.result;
    //     console.log(data);
    //   }
    // });
  }
}
</script>

<style lang="scss" scoped>
  .reveal-overlay {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1005;
    background-color: rgba(0,0,0,.45);
    overflow-y: auto;
    display: block;
    #contact-modal {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      z-index: 1006;
      backface-visibility: hidden;
      padding: 2.5rem 2rem 1.5rem;
      border: 1px solid #787d78;
      border-radius: .25rem;
      background-color: #fff;
      position: relative;
      overflow-y: auto;
      min-height: 0;
      right: auto;
      left: auto;
      margin: 0 auto;
      outline: 0;
      width: 50%;
      max-width: 81.75rem;
      top: 41px;
      display: block;
      .close-button {
        margin: 0;
        overflow: visible;
        text-transform: none;
        padding: 0;
        border: 0;
        background: 0 0;
        appearance: none;
        border-radius: .25rem;
        position: absolute;
        z-index: 10;
        color: #413e37;
        cursor: pointer;
        right: 1rem;
        top: .5rem;
        font-size: 2em;
        line-height: 1;
        outline: 0;
      }
      h4 {
        -webkit-font-smoothing: antialiased;
        overflow-wrap: break-word;
        margin: 0;
        padding: 0;
        font-style: normal;
        text-rendering: optimizeLegibility;
        margin-top: 0;
        margin-bottom: .875rem;
        font-size: 1.5rem;
        line-height: 1.33333;
        font-family: Montserrat,sans-serif;
        font-weight: 600;
        letter-spacing: -.0375rem;
      }
      .intro {
        line-height: 1.5;
        margin: 0;
        padding: 0;
        font-family: Montserrat,sans-serif;
        color: #888;
        font-weight: 400;
        letter-spacing: -.00625rem;
        font-size: 16px;
        max-width: 100%;
      }
      .text-right {
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
        font-weight: 400;
        line-height: 1.5;
        color: #053A7A;
        -webkit-font-smoothing: antialiased;
        margin: 0;
        padding: 0;
        text-align: right;
        margin-bottom: 0;
        button {
          overflow: visible;
          background: 0 0;
          display: inline-block;
          vertical-align: middle;
          margin: 0 0 1rem 0;
          border: 1px solid transparent;
          transition: background-color .25s ease-out,color .25s ease-out;
          -webkit-appearance: none;
          cursor: pointer;
          // background-color: #91c855;
          // color: #053A7A;
          background-color: #5456ff;
          color: #fff;
          font-size: .75rem;
          line-height: 1rem;
          padding: .6875rem 1.5rem;
          border-radius: 1.25rem;
          letter-spacing: 1px;
          text-align: center;
          font-weight: 600;
          text-transform: uppercase;
          min-width: 9.75rem;
          outline: 0;
          height: auto;
        }
      }
    }
  }
  .important-notice {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    padding: 0;
    color: #787d78;
    margin-bottom: 2.5rem;
    font-size: .75rem;
    line-height: 1rem;
    p {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
  }
  .agree-box {
    font-size: 100%;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    border-radius: .5rem;
    background-color: #f0f4f0;
    padding: 2.5rem;
    margin-bottom: 2.5rem;
    .consent-check-box {
      font-size: .75rem;
      line-height: 1rem;
      appearance: none;
    }

    .consent-check-label {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      -webkit-font-smoothing: antialiased;
      margin: 0;
      font-size: 1rem;
      line-height: 1.5rem;
      color: #053A7A;
      word-break: break-word;
      display: inline-block;
      vertical-align: baseline;
      margin-right: 1rem;
      margin-bottom: 1rem;
      position: relative;
      padding-left: 1.75rem;
      font-weight: 600!important;
      margin-left: .875rem;
      cursor: pointer;
    }

    .consent-check-label:before {
      background-image: url(../assets/imgs/checkbox.svg);
      width: 1.5rem;
      height: 1.5rem;
      position: absolute;
      top: 0.75rem;
      left: -0.75rem;
      content: '\A';
      background-repeat: no-repeat;
      background-size: contain;
      display: inline-block;
    }

    .checked:before {
      background-image: url(../assets/imgs/checkbox-checked.svg) !important;
    }
    .consent-sign {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif !important;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      margin: 0;
      padding: 0;
      min-width: 0;
      padding-right: .75rem;
      padding-left: .75rem;
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
      text-align: right;
      .text {
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif !important;
        font-weight: 400;
        line-height: 1.5;
        color: #053A7A;
        -webkit-font-smoothing: antialiased;
        text-align: right;
        margin: 0;
        padding: 0;
      }
    }
  }
  .consent-item-wrapper {
    margin-bottom: 2.5rem;
    .consent-item {
      padding: 2.5rem;
      border: 1px solid #c1c4c2;
      cursor: pointer;
      border-radius: 0.5rem;
      margin-bottom: 0.5rem;
      box-shadow: none;
      transition: box-shadow .1s ease-in-out;
      .media-wrap {
        margin-right: 1rem;
      }
      a {
        font-weight: 600;
        text-decoration: underline;
        color: #3282a0;
        cursor: pointer;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      }
    }
    .consent-item:hover {
        box-shadow: 0 0 16px rgba(0,0,0, 0.1);
    }
  }
  
  .flex-container {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .align-middle {
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
  }
  .consent-title {
    margin-bottom: 0.8125rem !important;
  }
  .intro {
    font-size: 100%;
    line-height: 1.5;
    margin: 0;
    padding: 0;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    color: #787d78;
    font-weight: 400;
    margin-bottom: 2.5rem;
    max-width: 39.375rem;
  }

  #application-notes {
    overflow: auto;
    min-height: 50px;
    display: block;
    box-sizing: border-box;
    margin: 0 0 1rem;
    border-radius: .25rem;
    background-color: #f0f4f0;
    box-shadow: none;
    font-weight: 600;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
    appearance: none;
    max-width: 100%;
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    width: 100%;
    margin-bottom: .5rem;
    border: 0;
    resize: vertical;
    height: auto;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  #application-notes:focus {
    box-shadow: 0 0 0 1px #787d78;
    border: 0;
    outline: 0;
  }

  .remove-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .review-section {
    .m-t-30 {
      margin-top: 1.875rem;
    }
    .amcredit-text {
      color: #053A7A;
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
    .sub-title-margin {
      margin-top: 35px;
    }
    .review-item {
      border-top: 1px solid #e3e6e3;
      border-bottom: 1px solid #e3e6e3;
      padding: 0.25rem 0;
      margin: -1px 0 0 -1px;
      word-break: break-word;
      width: 100%;
      .item-title {
        max-width: 50%;
        -webkit-flex: 0 0 50%;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        font-size: .75rem;
        line-height: 1rem;
        padding: 0.75rem 0;
        color: #787d78;
        margin: 0;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      }
      .item-value {
        max-width: 50%;
        -webkit-flex: 0 0 50%;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        text-align: right;
        color: #053A7A;
        font-weight: 600;
        font-size: .75rem;
        line-height: 1rem;
        font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
        margin: auto;
      }
    }
    .edit-review {
      height: 1.5rem;
      min-width: 0;
      border: 1px solid #91c855;
      color: #053A7A;
      background-color: transparent;
      outline: 0;
      font-size: .625rem;
      line-height: 1rem;
      padding: 0.25rem 1rem;
      border-radius: 1.25rem;
      letter-spacing: 1px;
      text-align: center;
      font-weight: 600;
      position: absolute;
      right: 0;
      display: inline-block;
      vertical-align: middle;
      margin: 0 0 1rem 0;
    }
    .sub-title {
      color: #538e37;
      font-size: .625rem;
      line-height: 1rem;
      font-weight: 600;
      letter-spacing: .0625rem;
      text-transform: uppercase;
    }
  }
  .delete-add-owner {
    font-size: 20px;
    color: #3282a0;
    text-decoration: none;
    cursor: pointer;
    margin-left: 46%;
  }

  .amcredit-add-owner {
    border: 1px solid #00234D;
    color: #053A7A;
    font-size: .75rem;
    line-height: 1rem;
    padding: 0.6875rem 1.5rem;
    border-radius: 1.25rem;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    min-width: 9.75rem;
  }
  .amcredit-add-owner:hover {
    border-color: #005fcc;
  }

  .address-check-box {
    font-size: .75rem;
    line-height: 1rem;
    appearance: none;
  }

  .address-check-label {
    cursor: pointer;
    font-weight: 400;
    margin-bottom: 0;
    position: relative;
    padding-left: 1.75rem;
    display: inline-block;
    vertical-align: baseline;
    margin-left: 0.5rem;
    margin-right: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  .address-check-label:before {
    background-image: url(../assets/imgs/checkbox.svg);
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
    top: 0;
    left: -0.5rem;
    content: '\A';
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
  }

  .checked:before {
    background-image: url(../assets/imgs/checkbox-checked.svg) !important;
  }

  hr {
    clear: both;
    height: 0;
    margin: 1.375rem 0;
    border-top: 0;
    border-right: 0;
    border-bottom: 1px solid #c1c4c2;
    border-left: 0;
  }

  label:empty {
      display: none;
  }
  @media print, screen and (min-width: 64em) {
    .minimal-title {
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      padding-bottom: 30px;
    }
  }
  .ls-1 {
    letter-spacing: .0625rem;
  }
  .text-12-16 {
      font-size: .75rem;
      line-height: 1rem;
  }
  .f-w-600 {
      font-weight: 600;
  }
  .uppercase {
      text-transform: uppercase;
  }
  .color-gray-5, .color-grey-5 {
      color: #053A7A;
  }
  .text-center {
      text-align: center;
  }
  .amcredit-font {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      /* font-weight: 400; */
      line-height: 1.5;
      color: #053A7A;
  }
  h3.title {
    margin-bottom: 2.5rem;
    letter-spacing: -.03125rem;
    max-width: 39.375rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #053A7A;
  }
  h5.color-green {
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-size: 1.25rem;
    line-height: 1.6;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #5456ff;
  }
  @media screen and (max-width: 768px) {
    .reveal-overlay {
      #contact-modal {
        width: 90%;
        h4 {
          font-size: 1.5rem !important;
        }
      }
    }
    .agree-box .consent-sign {
      margin-left: 32px;
    }
    .review-section {
      padding-right: 0 !important;
      margin-right: 0 !important;
      margin-left: -7.5px !important;
      .review-item .item-value {
        padding-right: 0 !important;
      }
      .edit-review {
        bottom: 0;
      }
      .sub-title-margin:nth-of-type(2) {
        margin-top: 0;
      }
    }
  }

</style>

<style lang="scss">
  .select-placeholder {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      top: 16px;
      left: 13px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: rgba(30,70,70,.5);
      transition: all .3s;
      pointer-events: none;
    }
    .select-top-placeholder.selected select~span.select-placeholder, .select-top-placeholder select:focus~span.select-placeholder {
      visibility: visible;
      opacity: 1;
      top: 9px;
      font-size: 10px;
      line-height: 12px;
    }

    select:focus ~ .select-placeholder{
      color: #50aad2;
    }

  
  .vue-form-generator .selected.select-top-placeholder .form-control {
    padding: 21px 16px 10px 12px;
    color: #053A7A;
  }

  .vue-form-generator .select-top-placeholder .form-control {
    color: rgba(30,70,70,.5);
  }

  .input-label-placeholder {
    input:not(:placeholder-shown)~span.placeholder {
      top: 55px;
      font-size: 10px;
      line-height: 12px;
    }
    .placeholder {
      position: absolute;
      top: 62px;
      left: 13px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 600;
      color: rgba(30,70,70,.5);
      transition: all .3s;
      pointer-events: none;
    }

    input:focus ~ .placeholder{
      left: 13px;
      color: #50aad2;
      top: 55px;
      font-size: 10px;
      line-height: 12px;
      font-weight: 600;
    }
  }
  .has-error .errors{
    color: red;
    span {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-size: 12px;
    }
  }
  .vue-form-wizard .wizard-header {
    padding-bottom: 40px !important;
  }
  .fa-hospital:before {
    content: "1 Equipment & Business Information" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-sun:before {
    content: "2 Owner Information" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-consent:before {
    content: "3 Consent" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .fa-rev:before {
    content: "4 Review" !important;
    height: 16px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .wizard-nav.wizard-nav-pills > li a .wizard-icon{
    color: #787d78;
  }
  .wizard-nav.wizard-nav-pills > li.active a .wizard-icon{
    color: #053A7A !important;
  }
  .wizard-nav.wizard-nav-pills > li:first-child a {
      border-left: 0;
  }
  .wizard-nav.wizard-nav-pills > li:last-child a {
      border-right: 0;
  }
  .wizard-nav.wizard-nav-pills > li a {
    border-left: 1px solid rgba(0,0,0,.1);
    border-right: 1px solid rgba(0,0,0,.1);
  }
  .vue-form-wizard .wizard-tab-content {
    padding-top: 60px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .vue-form-generator .form-group {
    padding-left: 0;
    padding-right: 0;
  }
  .vue-form-generator .form-group label{
    font-weight: 400;
    margin-bottom: 0.625rem;
    word-break: break-word;
    display: block;
    margin: 0;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #053A7A;
    margin-bottom: 0.625rem;
  }
  .vue-form-generator .form-group label span {
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }

  .radio-list label {
      position: relative;
      padding: 1rem 1.5rem;
      /* width: 12.8125rem; */
      display: inline-block !important;
      margin: 0 0 1rem 0;
      font-size: .75rem;
      line-height: 1rem;
      font-weight: 600!important;
      display: inline-block;
      background: #f0f4f0;
      border-radius: 0.25rem;
      border: 1px solid transparent;
      width: 49.5%;
      color: #053A7A;
      height: 3.4375rem;
  }

  .radio-list label:first-child {
    margin-right: 0.5%;
  }
  .radio-list label:last-child {
    margin-left: 0.5%;
  }

  .input-type-radio {
    display: block !important;
    input {
      margin-right: 10px;
    }
  }
  
  .input-type-number{
    input {
      height: 3.4375rem;
      margin: 0 0 0.625rem;
      padding: 1rem;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: 0;
      border-radius: 0.25rem;
      background-color: #f0f4f0;
      font-size: 1rem !important;
      font-weight: 600;
      line-height: 1.5;
      color: #053A7A !important;
      background-origin: content-box;
      background-position: right -1rem center;
      background-repeat: no-repeat;
      background-size: 9px 6px;
      padding-right: 1.5rem;
      transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
    }
  }

  .custom-input label[for="business-information"] {
    margin-top: 0;
    margin-bottom: 0.875rem;
    font-size: 1.25rem;
    line-height: 1.6;
    letter-spacing: -.03125rem;
    font-family: Montserrat,sans-serif;
    font-weight: 600;
    color: #5456ff;
  }

  .custom-input-padding {
    padding-top: 46px;
  }

  .custom-input {
    display: inline-block;
    margin-right: 0.25%;
    margin-bottom: 0 !important;
  }

  .custom-lg-8 {
    max-width: 66.916667% !important;
  }

  .custom-input select{
    margin-bottom: 0.625rem !important;
  }

  .custom-input input{
    height: 3.4375rem;
    margin: 0 0 0.625rem;
    padding: 1rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    background-color: #f0f4f0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    color: #053A7A;
    background-origin: content-box;
    background-position: right -1rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    padding-right: 1.5rem;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
  }

  .field-wrap select {
    height: 3.4375rem;
    margin: 0 0 1.75rem;
    padding: 1rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0.25rem;
    background-color: #f0f4f0;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
    color: #6c757d;
    background-origin: content-box;
    background-position: right -1rem center;
    background-repeat: no-repeat;
    background-size: 9px 6px;
    padding-right: 1.5rem;
    transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
  }

  .field-select.selected select  {
    color: #053A7A;
  }
  .wizard-card-footer {
    padding: 0 !important;
  }
  .vue-form-wizard .wizard-card-footer .wizard-footer-left {
    display: none;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-right {
    float: left !important;
  }
  .wizard-footer-right .wizard-btn{
    font-size: .75rem !important;
    line-height: 1rem !important;
    padding: 0.6875rem 1.5rem !important;
    border-radius: 1.25rem !important;
    letter-spacing: 1px !important;
    text-align: center !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    min-width: 9.75rem !important;
    background-color: #5456ff !important;
    color: #fff !important;
    border: 0 !important;
    max-width: 26.25rem !important;
    width: 420px !important;
    margin-top: 10px !important;
    margin-bottom: 40px !important;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }
  @media screen and (max-width: 768px) {
    .custom-lg-8 {
      max-width: 100% !important;
    }
    .wizard-footer-right .wizard-btn {
      width: 100% !important;
    }

    .custom-input-padding {
      padding-top: 0;

      input:not(:placeholder-shown)~span.placeholder {
        top: 9px;
      }
      .placeholder {
        top: 16px;
      }

      input:focus ~ .placeholder{
        top: 9px;
      }
    }
  }
  
</style>


// WEBPACK FOOTER //
// ApplyForm.vue?3cb88716